import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import _ from 'lodash';
import {
  FavoriteActionButton,
  FavoriteImage,
  PlayerButton,
} from '../HelperComponents/StyledComponents';

import { COLOR_ORANGE } from '../../constants';
import {
  stripUrlQueryParams,
} from '../../helpers';

import TuesdayCollectiveDefaultImg from '../../images/tuesday-collective-default.jpg';

import {
  fetchPlayerSong,
  playerSongPause,
  playerSongPauseToggle,
} from '../../actions/PlayerActions';

import { logOutAction } from '../../actions/UserActions';

import {
  requestSong
} from '../../actions/OrderActions';

import {
  addToFavorite,
  removeFromFavorite
} from '../../actions/FavoritesActions';

import {
  openModal
} from '../../actions/ModalLoginActions';

class SongRowComponent extends Component {
  static propTypes = {
    numeration: PropTypes.number,
    title: PropTypes.string,
    artist: PropTypes.string,
    genre: PropTypes.string,
    price: PropTypes.number,
    album: PropTypes.string,
    tempo: PropTypes.string,
    song: PropTypes.object,
    user: PropTypes.object,
  }

  static defaultProps = {
    song: {
      product_album: {}
    }
  }

  pauseSong = () => {
    this.props.playerSongPause();
  }

  playSong = () => {
    // if it's already active, toggle the pause state.
    if (this.props.isLoading) {
      return;
    }

    if (this.props.isActive) {
      // if it is playing, then pass 'true' for the shouldPause param
      this.props.playerSongPauseToggle(this.props.isPlaying);
    } else {
      this.props.fetchPlayerSong(this.props.song);
    }
  }

  addSongToCart = () => {
    this.props.requestSong(this.props.song);
  }


  openModal = () => {
    this.props.openModal();
  }

  getTrackStyleProperty = song => {
    // account for different apis
    if (song.style_title) {
      return song.style_title;
    }

    let styles = _.values(song.product_style);
    return styles.map((sty) => sty.post_title).join(', ');
  }

  render() {
    let songNumber = this.props.numeration + 1;
    let song = this.props.song;
    let album = song.product_album;
    let tempo = _.values(song.product_tempo);
    const isAlreadyAFavorite = this.props.favorites.items.find((favorite) => favorite.id === song.id);
    // correct for different title formats
    const songTitle = song.title ? song.title.rendered : song.post_title;
    const trackStyleProperty = this.getTrackStyleProperty(song);

    // todo quick fixes for data
    album = Object.assign(album, {
      id: album.id || album.ID,
    });

    // quick fix. Only set the download link if the user is logged in. Encourage them to log in.
    if (this.props.user && this.props.user.authenticated) {
      song = Object.assign(song, {
        product_download_url: stripUrlQueryParams(song.product_file && song.product_file.url),
      });
    };

    // todo quick fixes for data
    if (!album.url) {
      let albumCover = album.albumn_cover || album.album_cover || {};
      album.url = albumCover.url || TuesdayCollectiveDefaultImg;
    }

    const albumUrl = stripUrlQueryParams(album.url);

    return (
      <tr className={this.props.isActive ? 'is-active' : ''}>
        <td className="has-text-centered is-narrow">
          {
            !this.props.shouldShowAlbumCover &&
            <p className="song-row-index" id="song-row-index">{songNumber < 10 ? '0' + songNumber: songNumber}.</p>
          }
          {
            this.props.isLoading ?
            <PlayerButton className="icon-play is-loading" theme={{ padding: '10px', fontSize: '19px' }}></PlayerButton> :
              this.props.isPlaying ?
              <PlayerButton className="icon-pause" onClick={this.pauseSong} theme={{ padding: '10px', fontSize: '19px' }}></PlayerButton> :
              <PlayerButton className="icon-play" onClick={this.playSong} theme={{ padding: '10px', fontSize: '19px' }}></PlayerButton>
          }
          {
            this.props.shouldShowAlbumCover &&
            <figure className="album-cover-image image is-32x32" id="song-row-index">
              <FavoriteImage src={albumUrl || TuesdayCollectiveDefaultImg} />
            </figure>
          }
        </td>
        <td className="is-hidden-tablet">
          <section>
            <p onClick={this.playSong}>{songTitle}</p>
            <p>{album.post_title}</p>
            <p>Tempo: {tempo.map((temp) => temp.name)}</p>
          </section>
        </td>
        <td className="is-hidden-mobile" onClick={this.playSong} style={{ cursor: 'pointer' }}>{songTitle}</td>
        <td className="is-hidden-mobile">
          {
            this.props.shouldLinkAlbumTitle &&
            <Link to={`/album/${album.id}`} style={{ color: 'white' }}>{album.post_title}</Link>
          }
          {
            !this.props.shouldLinkAlbumTitle &&
            <span style={{ color: 'white' }}>{album.post_title}</span>
          }
        </td>
        <td className="is-hidden-mobile">{trackStyleProperty}</td>
        <td className="is-hidden-mobile">{tempo.map((temp) => temp.name).join(', ')}</td>
        <td className="has-text-right">
          <a href={song.product_download_url}
            target="_blank"
            aria-label={`download song: ${songTitle}`}
            rel="noopener noreferrer"
            style={{ color: 'white' }}
            onClick={this.openModal}
            download
          >
            <FavoriteActionButton className="icon-download">
            </FavoriteActionButton>
          </a>
          { isAlreadyAFavorite ?
            <FavoriteActionButton className="icon-heart2" theme={{ color: COLOR_ORANGE }} onClick={() => {
              const promise = this.props.removeFromFavorite(song.id);
              // note removeFromFavorite only returns a promise if the user is logged in and it does something.
              if (promise) {
                promise.catch(e => {
                  this.props.logOutAction(this.props.history);
                });
              }

            }}></FavoriteActionButton>
            :
            <FavoriteActionButton className="icon-heart" theme={{ color: COLOR_ORANGE }} onClick={() => {
              const promise = this.props.addToFavorite(song);
              // note addToFavorite only returns a promise if the user is logged in and it does something.
              if (promise) {
                promise.catch(e => {
                  this.props.logOutAction(this.props.history);
                });
              }
            }}></FavoriteActionButton>
          }
          <FavoriteActionButton className="icon-shopping-cart-add" onClick={() => { this.openModal(); this.addSongToCart(); }}></FavoriteActionButton>
        </td>
      </tr>
    );
  }
}

function mapStateToProps({ user, favorites }) {
  return {
    favorites,
    user,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addToFavorite,
    openModal,
    requestSong,
    playerSongPause,
    playerSongPauseToggle,
    fetchPlayerSong,
    removeFromFavorite,
    logOutAction,
  }, dispatch);
}

export const SongRow = withRouter(connect(mapStateToProps, mapDispatchToProps)(SongRowComponent));


// WEBPACK FOOTER //
// ./src/components/SongRow/SongRow.js